import React, { useMemo, useState } from "react";
import Modal from "Components/Common/GenericModal";
import Button from "Components/Common/Button";
import "./styles.scss";

interface Professional {
  id: string;
  name: string;
  category: string;
  avatar?: string;
}

interface AssignIssueModalProps {
  isOpen: boolean;
  onClose: () => void;
  professionals?: Professional[];
  onAssign?: (professional: Professional | null) => void;
}

const AssignIssueModal: React.FC<AssignIssueModalProps> = ({
  isOpen,
  onClose,
  professionals = [],
  onAssign,
}) => {
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return professionals;
    return professionals.filter((p) =>
      `${p.name} ${p.category}`.toLowerCase().includes(q)
    );
  }, [query, professionals]);

  const handleConfirm = () => {
    const prof = professionals.find((p) => p.id === selectedId) ?? null;
    if (onAssign) onAssign(prof);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" closable>
      <div className="assign-issue-modal">
        <div className="assign-header">Assign Issue to Professional</div>
        <div className="text-muted fs-9 mb-3">
          Assign the issue to a professional based on their expertise.
        </div>

        <div className="assign-search">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search here..."
          />
        </div>

        <div className="assign-list">
          {filtered && filtered.length > 0 ? (
            filtered.map((p) => (
              <div
                key={p.id}
                className={`assign-item ${
                  selectedId === p.id ? "selected" : ""
                }`}
                onClick={() => setSelectedId(p.id)}
              >
                <div className="assign-item-left">
                  <div className="assign-name">{p.name}</div>
                  <div className="assign-role">{p.category}</div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-muted">No professionals found.</div>
          )}
        </div>

        <div className="assign-footer">
          <div className="d-flex gap-3">
            <Button
              variant="primary"
              size="lg"
              onClick={handleConfirm}
              disabled={!selectedId}
              icon={<img src="/assets/icons/RightIcon.png" alt="Forward" />}
              iconPosition="right"
            >
              Assign
            </Button>
            <div className="assign-cancel" onClick={onClose}>
              Cancel
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AssignIssueModal;
